// The hero "when" panel calendar (design `calCells`): a Monday-first month grid with
// leading blanks, past days disabled and today outlined. Pure, so the grid maths is
// tested without a DOM.
export interface MonthCell {
  // null for the leading blanks before the 1st.
  iso: string | null;
  day: number;
  past: boolean;
  today: boolean;
}

export function isoDate(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// `month` is 0-based (Date#getMonth). `now` decides which days are past.
export function monthCells(year: number, month: number, now: Date): MonthCell[] {
  const todayIso = isoDate(now);
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const days = new Date(year, month + 1, 0).getDate();
  const offset = (new Date(year, month, 1).getDay() + 6) % 7; // Monday-first
  const cells: MonthCell[] = [];
  for (let i = 0; i < offset; i++) cells.push({ iso: null, day: 0, past: false, today: false });
  for (let d = 1; d <= days; d++) {
    const date = new Date(year, month, d);
    const iso = isoDate(date);
    cells.push({ iso, day: d, past: date < startOfToday, today: iso === todayIso });
  }
  return cells;
}
